<template>
  <v-container fluid class="py-0" grid-list-md>
    <v-row justify="center">
      <v-col cols="12">
        <v-flex xs12 md9 v-if="lAction === 'view'" mx-auto>
          <v-card-title class="title primary--text">
            Search Compensation
          </v-card-title>
          <v-form ref="sForm" @submit.prevent="searchEmployee()">
            <v-card>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-text-field
                    v-model="lSearch.emp_name"
                    label="Employee Name"
                    hide-details
                    maxlength="50"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    v-model="lSearch.emp_desig"
                    label="Designation"
                    hide-details
                    maxlength="35"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    v-model="lSearch.vendor_emp_id"
                    label="Employee Id"
                    hide-details
                    maxlength="6"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    v-model="lSearch.aadhar_no"
                    label="AADHAR No."
                    hide-details
                    maxlength="20"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    v-model="lSearch.proj_name"
                    label="Assigned To Project"
                    hide-details
                    maxlength="50"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                    v-model="lSearch.emp_status"
                    label="Status"
                    :items="['On Job', 'In Bench', 'Resigned', 'Terminated']"
                    hide-details
                    ></v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-checkbox
                    v-model="lSearch.emp_with_no_project"
                    label="Employee With NO Active Projects"
                    hide-details
                    class="shrink"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs6>
                    <v-checkbox
                    v-model="lSearch.emp_with_project"
                    label="Employee With Active Projects"
                    hide-details
                    class="shrink"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="clear">Clear</v-btn>
                <v-btn type="submit" color="accent" :disabled="beingSaved">search</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-flex>

        <v-flex xs12 class="pt-2" v-if="lAction === 'view' && searchRes.length > 0">
          <v-card-title class="title primary--text">
            Search Result ({{searchRes.length}} Records)
          </v-card-title>
          <v-card>
            <v-card-text class="pa-0">
              <v-data-table
              :headers="emp"
              :items="searchRes"
              hide-default-footer
              disable-pagination
              :sort-by="['emp_name', 'vendor_emp_id']"
              multi-sort
              :mobile-breakpoint="0"
              >
              <template slot="item" slot-scope="props">
                <tr>
                  <td>{{ props.item.emp_name }}</td>
                  <td>{{ props.item.vendor_emp_id }}</td>
                  <td>{{ props.item.emp_desig || '-' }}</td>
                  <td>{{ props.item.act_proj_list || '-' }}</td>
                  <td>{{ props.item.takehome_salary }}</td>
                  <td>{{ props.item.emp_status }}</td>
                  <td>
                    <v-menu bottom left>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="prepareUpdate(props.item)">
                          <v-list-item-title>Update</v-list-item-title>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item @click="prepareRevise(props.item)">
                          <v-list-item-title>Revise Compensation</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="viewRevision(props.item)">
                          <v-list-item-title>View Revision History</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-btn
      :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; left:65px;':'bottom:15px; left:340px;')"
      dark fab fixed color="accent" v-if="lAction==='view'"
      @click.native="prepareCreate">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-btn v-if="lAction === 'view'"
    :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; left:15px;':'bottom:15px; left:290px;')"
    dark fab fixed small
    color="accent"
    @click.native="prepareUpload">
    <v-icon>mdi-upload</v-icon>
  </v-btn>

  <!-- create, update and revise -->
  <v-container v-if="lAction === 'create' || lAction === 'update' ||  lAction === 'revise'" class="pa-0" fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 md9 mx-auto>
        <v-form ref="cForm" @submit.prevent="saveCompensation(lAction)">
          <v-card flat>
            <v-card-title class="title pb-2">
              <span v-if="lAction === 'create'">Create Compensation</span>
              <span v-else>{{lComp.emp_name + ' (' + lComp.vendor_emp_id + ')'}}</span>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs8 sm4 v-if="lAction==='update' || lAction ==='revise'">
                  <v-dialog ref="dlgstartDt"
                  persistent v-model="dlgstartDt"
                  max-width="290px"
                  class="pt-0"
                  :return-value.sync="lComp.effective_from">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    slot="activator"
                    label="Effective From"
                    v-model="lComp.effective_from" append-icon="mdi-calendar-today"
                    :rules="[rules.required]"
                    readonly
                    v-on="on"
                    hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker
                  v-model="lComp.effective_from"
                  scrollable
                  >
                  <div class="flex-grow-1"></div>
                  <v-btn text @click="dlgstartDt = false">Cancel</v-btn>
                  <v-btn text color="accent" @click="$refs.dlgstartDt.save(lComp.effective_from)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs4 sm8 v-if="lAction==='update' || lAction ==='revise'">
            </v-flex>
            <v-flex xs12 sm8 v-if="lAction === 'create'">
              <v-combobox
              v-model="lComp.emp_pair"
              label="Employee"
              item-value="emp_id"
              item-text="emp_name_with_id"
              :items="showAllEmp ? empList : empList.filter(rec => !rec.compen_id)"
              :rules="[rules.required]"
              :hint="(!showAllEmp ? 'List of active employees with no compensation (' + empList.filter(rec => !rec.compen_id).length + ')': 'All active employees (' + empList.length + ')')"
              persistent-hint
              clearable
              ></v-combobox>
            </v-flex>
            <v-flex xs12 sm4 v-if="lAction === 'create'" class="text-xs-right">
              <v-switch
              v-model="showAllEmp"
              label="Show all employees"
              :class="$vuetify.breakpoint.smAndDown ? 'mt-0' : 'mb-3'"
              @change="$forceUpdate()"
              ></v-switch>
            </v-flex>
            <v-flex xs4>
              <v-text-field
              v-model="lComp.takehome_salary"
              label="Takehome Salary"
              hide-details
              maxlength="11"
              type="number"
              :rules="[rules.required]"
              class="title"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
              v-model="lComp.budgeted_salary"
              label="Budgeted Salary"
              hide-details
              maxlength="11"
              type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
              v-model="lComp.billing_salary"
              label="Billing Salary"
              hide-details
              maxlength="11"
              type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 class="mt-3">
              <span class="primary--text">Salary Breakup</span>
            </v-flex>
            <v-flex xs4>
              <v-text-field
              v-model="lComp.basic"
              label="Basic"
              hide-details
              maxlength="11"
              type="number"
              @input="computed"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
              v-model="lComp.da"
              label="DA"
              hide-details
              maxlength="11"
              type="number"
              @input="computed"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
              v-model="lComp.hra"
              label="HRA"
              hide-details
              maxlength="11"
              type="number"
              @input="computed"
              :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
              v-model="lComp.conveyance"
              label="Conveyance"
              hide-details
              maxlength="11"
              type="number"
              @input="computed"
              :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
              v-model="lComp.washing_allowance"
              label="Washing Allowance"
              hide-details
              maxlength="11"
              type="number"
              @input="computed"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
              v-model="lComp.other_allowance"
              label="Other Allowance"
              hide-details
              maxlength="11"
              type="number"
              @input="computed"
              :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
              v-model="lComp.leave_wages"
              label="Leave Wages"
              hide-details
              maxlength="11"
              type="number"
              @input="computed"
              :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
              v-model="lComp.medical_reimb"
              label="Medical Reimbursement"
              hide-details
              maxlength="11"
              type="number"
              @input="computed"
              :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
              v-model="lComp.food_coupon"
              label="Food Coupon"
              hide-details
              maxlength="11"
              type="number"
              @input="computed"
              :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
              v-model="lComp.performance_incentive"
              label="Performance Incentive"
              hide-details
              maxlength="11"
              type="number"
              @input="computed"
              :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
              v-model="lComp.bonus"
              label="Bonus"
              hide-details
              maxlength="11"
              type="number"
              @input="computed"
              :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
              v-model="lComp.child_edu_allowances"
              label="Child Educational Allowance"
              hide-details
              maxlength="11"
              type="number"
              @input="computed"
              :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
              v-model="lComp.other_amt"
              label="Other Amount"
              hide-details
              maxlength="11"
              type="number"
              @input="computed"
              :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs8 class="mt-2">
              <v-alert outlined :value="true" class="px-0 py-2 primary--text text-center">
                <b>Gross Salary: {{handy.formatCur(lComp.gross_salary)}}</b>
              </v-alert>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="lAction === 'update'" @click="deleteEmpComp(lComp)">delete</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click.stop="cancelChanges()">Cancel</v-btn>
          <v-btn type="submit" color="accent" :disabled="beingSaved">save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-flex>
</v-layout>
</v-container>

<v-container v-if="lAction === 'upload'" class="pa-0" fluid full-height>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pa-0 pl-3">
          Upload Compensation
        </v-card-title>
        <div class="mt-3 text-center primary--text title font-italic">In just 4 steps</div>
        <v-card-text class="subtitle-1 black--text">
          <v-layout row wrap>
            <v-flex xs12>
              <v-chip small outlined class="info info--text mr-2">Step 1</v-chip>
              <span>Download template</span>
              <span style="float:right;">
                <form method="get" action="/files/Vendor_List_Template.xlsx">
                  <v-btn type="submit" class="mt-0 mb-0" small><v-icon>mdi-download</v-icon></v-btn>
                </form>
              </span>
            </v-flex>
            <v-flex xs12>
              <v-chip small outlined class="info info--text mr-2">Step 2</v-chip>
              <span>Fill-in details as guided in template</span>
            </v-flex>
            <v-flex xs12>
              <v-chip small outlined class="info info--text mr-2">Step 3</v-chip>
              <span>Save as CSV <span class="caption">(Comma delimited)</span><br />
              <span class="caption grey--text pl-4 ml-4">
                <span class="ml-4">Go with OK/Yes when prompted while saving</span>
              </span>
            </span>
          </v-flex>
          <v-flex xs12>
            <v-chip small outlined class="info info--text mr-2">Step 4</v-chip>
            <span>Upload the CSV file</span>
            <span style="float:right;"><v-btn small class="mt-0 mb-0 accent" @click.native="promptUpload"><v-icon>mdi-upload</v-icon></v-btn></span>
            <input style="display:none" ref="ipFile" type="file" accept=".csv" @change="validateFile()"/>
          </v-flex>
          <v-flex xs12>
            <div class="mt-3 text-center primary--text title font-italic">Smartility BackBone takes care of rest</div>
          </v-flex>
          <v-flex xs12>
            <v-chip small outlined class="info info--text mr-2">Step 5</v-chip>
            <span>Validate your information</span>
          </v-flex>
          <v-flex xs12>
            <v-chip small outlined class="info info--text mr-2">Step 6</v-chip>
            <span>Create compensation</span>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn @click.native="cancelChanges">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</v-layout>
</v-container>

<!-- validate and upload -->
<v-container v-if="lAction === 'validate'" class="pa-0" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pa-0 pl-3">
          Upload Compensation
        </v-card-title>
        <v-card-text class="text-center pl-2 pr-2">
          <v-layout row wrap>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12 class="info--text mb-2">
                  <span v-if="validateInProgress">Loading and validating the file...</span>
                  <span v-if="validFile && !validateInProgress">File validation is successfull <v-icon class="success--text">mdi-check</v-icon></span>
                  <span v-if="!validFile">File validation is failed <v-icon class="error--text">mdi-close</v-icon></span>
                  <span v-if="!validFile && headerIssue" class="error--text"><br />Invalid column headers, please ensure names and count are matching as per the template</span>
                  <span v-if="!validFile && !headerIssue" class="error--text"><br />One or more invalid records, review the table below.<br/>Click on the errored row to know more info.</span>
                  <span v-if="!totFail && !loadInProgress">Compensation uploade was successfull<v-icon class="success--text">mdi-check</v-icon></span>
                  <span v-if="!totLoaded && totFail && !loadInProgress"><br />Compensation of employee creation failed<v-icon class="error--text">mdi-close</v-icon></span>
                  <span v-if="totLoaded && totFail && !loadInProgress"><br />Compensation of employee partially failed<v-icon class="warning--text">mdi-close</v-icon></span>
                  <span v-if="totFail && !loadInProgress" class="error--text"><br />One or more failed records, review the table below.<br/>Click on the errored row to know more info.</span>
                </v-flex>
                <v-flex xs4 v-if="totRecs">
                  <v-progress-circular color="info"
                  :value="readyForLoad ? 100 : (recsLoaded.length/totRecs*100)"
                  :size="50" :width="7">
                  {{ readyForLoad ? totValid : recsLoaded.length }}
                </v-progress-circular>
                <br/><div class="caption grey--text">Records</div>
              </v-flex>
              <v-flex xs4 v-if="totRecs">
                <v-progress-circular color="success"
                :value="(totValid/totRecs*100)"
                :size="50" :width="7">
                {{ readyForLoad ? totLoaded : totValid }}
              </v-progress-circular>
              <br/><div class="caption grey--text">{{ readyForLoad ? 'Loaded' : 'Valid' }}</div>
            </v-flex>
            <v-flex xs4 v-if="totRecs">
              <v-progress-circular color="error"
              :value="(totInvalid/totRecs*100)"
              :size="50" :width="7">
              {{ readyForLoad ? totFail : totInvalid }}
            </v-progress-circular>
            <br/><div class="caption grey--text">{{ readyForLoad ? 'Failed' : 'Invalid' }}</div>
          </v-flex>
          <v-flex xs12>
            <v-btn class="mr-4" small @click.native="lAction='view'">{{!totFail && !loadInProgress ? 'Back' : 'Cancel'}}</v-btn>
            <v-btn v-if="totValid > 0" small class="accent" @click.native="uploadCompensation" :disabled="beingSaved">Process the valid records</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 class="text-right">
        <v-btn small @click.native="FailedCompensation">View Failed Records ({{ recsLoaded.filter(rec =>rec.load_status === 'Failed').length }})</v-btn>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
        :headers="headersm"
        :items="recsLoaded"
        hide-default-footer
        :mobile-breakpoint="0"
        class="elevation-3 text-center"
        disable-pagination
        >
        <template slot="item" slot-scope="props">
          <tr :class="(props.item.error ? (props.item.load_status === 'Failed' ? 'error':'error--text') : (props.item.load_status === 'Loaded' ? 'success' : ''))" @click="props.item.error ? showError(props.item.error) : ''">
            <td>{{ props.item.vendor_emp_id }}</td>
            <td>{{ props.item.emp_name }}</td>
            <td>{{ props.item.takehome_salary }}</td>
            <td>{{ props.item.budgeted_salary }}</td>
            <td>{{ props.item.billing_salary }}</td>
            <td>{{ props.item.basic }}</td>
            <td>{{ props.item.da }}</td>
            <td>{{ props.item.hra }}</td>
            <td>{{ props.item.conveyance }}</td>
            <td>{{ props.item.washing_allowance }}</td>
            <td>{{ props.item.other_allowance }}</td>
            <td>{{ props.item.leave_wages }}</td>
            <td>{{ props.item.medical_reimb }}</td>
            <td>{{ props.item.food_coupon }}</td>
            <td>{{ props.item.performance_incentive }}</td>
            <td>{{ props.item.bonus }}</td>
            <td>{{ props.item.child_edu_allowances }}</td>
            <td>{{ props.item.other_amt }}</td>
            <td>{{ props.item.effective_from }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</v-card-text>
<v-card-actions class="pt-0" v-if="false">
  <v-spacer></v-spacer>
  <v-btn @click.native="cancelChanges">Cancel</v-btn>
</v-card-actions>
</v-card>
</v-flex>
</v-layout>
</v-container>

<v-dialog v-model="dlgRevHistory" persistent max-width="450px">
  <v-card flat scrollable v-if="lComp">
    <v-card-title class="caption grey lighten-4">
      {{lComp.emp_name + ' (' + lComp.vendor_emp_id + ')'}}
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="dlgRevHistory = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <div class="info white--text title text-center mb-2">
        {{(revHistory.length > 1 ? (revHistory.length - 1) : 'No') + ' revision' + (revHistory.length > 2 ? 's' : '')}}
      </div>
      <v-data-table
      :headers="revHeader"
      :items="revHistory"
      hide-default-footer
      :mobile-breakpoint="0"
      class="elevation-0">
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{props.index === 0 ? 'Original' : 'Revision'}}</td>
          <td>{{ handy.formatDate(props.item.effective_from) }}</td>
          <td>{{ props.item.effective_till ? handy.formatDate(props.item.effective_till) : ''}}</td>
          <td>{{ props.item.takehome_salary }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-dialog>

<v-dialog v-model="showFailedRecords" persistent max-width="1000px">
  <v-card flat scrollable>
    <v-card-title class="primary--text grey lighten-4 pa-2">
        <span>Failed Records({{recsLoaded.filter(rec =>rec.load_status === 'Failed').length}})</span>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showFailedRecords = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="headersm"
      :items="recsLoaded.filter(rec =>rec.load_status === 'Failed')"
      hide-default-footer
      :mobile-breakpoint="0"
      class="elevation-0">
      <template slot="item" slot-scope="props">
        <tr :class="props.item.load_status === 'Failed' ? 'error' : ''" @click="props.item.error ? showError(props.item.error) : ''">
          <td>{{ props.item.vendor_emp_id }}</td>
          <td>{{ props.item.emp_name }}</td>
          <td>{{ props.item.takehome_salary }}</td>
          <td>{{ props.item.budgeted_salary }}</td>
          <td>{{ props.item.billing_salary }}</td>
          <td>{{ props.item.basic }}</td>
          <td>{{ props.item.da }}</td>
          <td>{{ props.item.hra }}</td>
          <td>{{ props.item.conveyance }}</td>
          <td>{{ props.item.washing_allowance }}</td>
          <td>{{ props.item.other_allowance }}</td>
          <td>{{ props.item.leave_wages }}</td>
          <td>{{ props.item.medical_reimb }}</td>
          <td>{{ props.item.food_coupon }}</td>
          <td>{{ props.item.performance_incentive }}</td>
          <td>{{ props.item.bonus }}</td>
          <td>{{ props.item.child_edu_allowances }}</td>
          <td>{{ props.item.other_amt }}</td>
          <td>{{ props.item.effective_from }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-col>
</v-row>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  data () {
    return {
      lAction: '',
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      lSearch: {},
      handy: handy,
      rules: handy.rules,
      beingSaved: false,
      lComp: [],
      dlgstartDt: false,
      emp: [
        { text: 'Name', value: 'emp_name' },
        { text: 'Employee Id', value: 'vendor_emp_id' },
        { text: 'Designation', value: 'emp_desig' },
        { text: 'Active Project', value: 'act_proj_list', width: '200px' },
        { text: 'Takehome Salary', value: 'takehome_salary', width: '200px' },
        { text: 'Status', value: 'emp_status' },
        { text: '', sortable: false, value: 'action' }
      ],
      searchRes: [],
      empList: [],
      showAllEmp: false,

      // file upload
      validateInProgress: true,
      readyForLoad: false,
      loadInProgress: true,
      validFile: true,
      headerIssue: false,
      fileError: false,
      totRecs: 0,
      recsLoaded: [],
      totValid: 0,
      totInvalid: 0,
      totLoaded: 0,
      totFail: 0,
      headersm: [
        { text: 'Employee Id', value: 'vendor_emp_id' },
        { text: 'Employee Name', value: 'emp_name' },
        { text: 'Takehome Salary', value: 'takehome_salary' },
        { text: 'Budgeted Salary', value: 'budgeted_salary' },
        { text: 'Billing Salary', value: 'billing_salary' },
        { text: 'Basic', value: 'basic' },
        { text: 'DA', value: 'da' },
        { text: 'HRA', value: 'hra' },
        { text: 'Conveyance', value: 'conveyance' },
        { text: 'Washing Allowance', value: 'washing_allowance' },
        { text: 'Other Allowance', value: 'other_allowance' },
        { text: 'Leave Wages', value: 'leave_wages' },
        { text: 'Medical Reimbursement', value: 'medical_reimb' },
        { text: 'Food Coupon', value: 'food_coupon' },
        { text: 'Performance Incentive', value: 'performance_incentive' },
        { text: 'Bonus', value: 'bonus' },
        { text: 'Child Educational Allowance', value: 'child_edu_allowances' },
        { text: 'Other Amount', value: 'other_amt' },
        { text: 'Effective From', value: 'effective_from' },
      ],
      reqHeaders: ['Employee Id', 'Employee Name', 'Takehome Salary', 'Budgeted Salary', 'Billing Salary', 'Basic', 'DA', 'HRA', 'Conveyance', 'Washing Allowance', 'Other Allowance', 'Leave Wages', 'Medical Reimbursement', 'Food Coupon', 'Performance Incentive', 'Bonus', 'Child Educational Allowance', 'Other Amount'],
      colNames: [
        {col_name: 'vendor_emp_id', is_required: true},
        {col_name: 'emp_name', is_required: true},
        {col_name: 'takehome_salary', is_required: true},
        {col_name: 'budgeted_salary', is_required: false},
        {col_name: 'billing_salary', is_required: false},
        {col_name: 'basic', is_required: false},
        {col_name: 'da', is_required: false},
        {col_name: 'hra', is_required: false},
        {col_name: 'conveyance', is_required: false},
        {col_name: 'washing_allowance', is_required: false},
        {col_name: 'other_allowance', is_required: false},
        {col_name: 'leave_wages', is_required: false},
        {col_name: 'medical_reimb', is_required: false},
        {col_name: 'food_coupon', is_required: false},
        {col_name: 'performance_incentive', is_required: false},
        {col_name: 'bonus', is_required: false},
        {col_name: 'child_edu_allowances', is_required: false},
        {col_name: 'other_amt', is_required: false},
        {col_name: 'effective_from', is_required: false}
      ],
      dlgstartDt: false,
      dlgRevHistory: false,
      revHistory: [],
      revHeader: [
        { text: 'Type', value: '' },
        { text: 'Effective From', value: 'effective_from' },
        { text: 'Effective Till', value: 'effective_till' },
        { text: 'Takehome Salary', value: 'takehome_salary'}
      ],
      showFailedRecords: false
    }
  },
  mounted () {
    this.lAction = 'view'
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    computed () {
      this.lComp.gross_salary = Number(this.lComp.basic || 0) + Number(this.lComp.da || 0) + Number(this.lComp.hra || 0) + Number(this.lComp.conveyance || 0) + Number(this.lComp.washing_allowance || 0) + Number(this.lComp.other_allowance || 0) + Number(this.lComp.leave_wages || 0) + Number(this.lComp.medical_reimb || 0) + Number(this.lComp.food_coupon || 0) + Number(this.lComp.performance_incentive || 0) + Number(this.lComp.bonus || 0) + Number(this.lComp.child_edu_allowances) + Number(this.lComp.other_amt || 0)
    },
    clear () {
      this.$refs.sForm.reset()
    },
    getEmptyCompensation () {
      var emptyComp = {
        emp_id: '',
        emp_pair: '',
        takehome_salary: 0,
        budgeted_salary: 0,
        billing_salary: 0,
        basic: 0,
        da: 0,
        hra: 0,
        conveyance: 0,
        washing_allowance: 0,
        other_allowance: 0,
        leave_wages: 0,
        medical_reimb: 0,
        food_coupon: 0,
        performance_incentive: 0,
        bonus: 0,
        child_edu_allowances: 0,
        other_amt: 0,
        gross_salary: 0,
        effective_from: ''
      }
      return emptyComp
    },
    prepareCreate () {
      this.lComp = this.getEmptyCompensation()
      this.lAction = 'create'
      this.loadEmployee()
    },
    prepareUpdate(curComp) {
      this.lComp = Object.assign({}, curComp)
      this.lAction = 'update'
      this.lComp.effective_from = handy.formatDBDate(this.lComp.effective_from)
      this.computed()
      this.loadEmployee()
    },
    prepareRevise (curRec) {
      this.lComp = Object.assign({}, curRec)
      this.lAction = 'revise'
      this.computed()
      this.loadEmployee()
      this.lComp.effective_from = null
    },
    viewRevision (curComp) {
      this.lComp = Object.assign({}, curComp)
      var qry = {
        params: {
          emp_id: curComp.emp_id
        }
      }
      this.axios.get(config.API_URL + '/getEmpCompenRevisions/', qry)
      .then(response => {
        this.revHistory = response.data
        this.dlgRevHistory = true
      })
      .catch(err => {
        this.msg(err)
        this.revHistory = []
      })
    },
    saveCompensation (action) {
      // validate and save Changes
      if (this.$refs.cForm.validate()) {
        if (this.lAction==='revise' && !this.lComp.effective_from) {
          this.msg('Pls enter the effective from date', 0)
          return
        }
        this.beingSaved = true
        if (this.lAction === 'create') {
          this.lComp.emp_id = this.lComp.emp_pair.emp_id
        } else if (this.lAction === 'revise') {
          let effectiveTill = new Date(this.lComp.effective_from)
          this.lComp.effective_till = handy.formatDBDate(effectiveTill.setDate(effectiveTill.getDate() - 1))
        } else {
          this.lComp.effective_till = null
        }
        this.axios.post(config.API_URL + '/compensation/' + action, this.lComp)
        .then(response => {
          this.searchEmployee()
          this.msg('Saved successfully', 1)
          this.lAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      }
    },
    deleteEmpComp () {
      if (!confirm('Sure, you want to delete the compensation of employee "' + this.lComp.emp_name + '"?')) {
        return
      }
      // delete employee
      this.axios.post(config.API_URL + '/compensation/delete', this.lComp)
      .then(response => {
        // commit the changes in front end as well
        this.searchEmployee()
        this.msg('Deleted successfully', 1)
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    loadEmployee () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getEmpCompenByVendorId/', qry)
      .then(response => {
        this.empList = response.data.filter(rec => rec.emp_status === 'On Job' || rec.emp_status === 'In Bench')
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err)
        this.empList = []
        this.beingSaved = false
      })
    },
    searchEmployee () {
      if (!this.lSearch.emp_name && !this.lSearch.vendor_emp_id && !this.lSearch.aadhar_no
        && !this.lSearch.emp_desig && !this.lSearch.proj_name && !this.lSearch.emp_status
        && !this.lSearch.emp_with_project && !this.lSearch.emp_with_no_project) {
          this.msg('Please enter any search criteria', 0)
          return
        }
        var qry = {
          params: {
          }
        }
        qry.params = this.lSearch
        qry.params.vendor_id = config.VENDOR_ID
        this.beingSaved = true
        this.axios.get(config.API_URL + '/searchCompensationOfEmp/', qry)
        .then(response => {
          this.searchRes = response.data
          if (!this.searchRes.length) {
            this.msg('No compensation records found for given search criteria', 0)
          }
          this.lAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err)
          this.searchRes = []
          this.beingSaved = false
        })
      },
      prepareUpload () {
        this.lAction = 'upload'
      },
      promptUpload () {
        this.$refs.ipFile.click()
      },
      cancelChanges () {
        this.beingSaved = false
        this.lAction = 'view'
      },
      FailedCompensation () {
        this.showFailedRecords = true
      },
      validateFile () {
        this.lAction = 'validate'
        this.validateInProgress = true
        this.loadInProgress = true
        this.validFile = true
        this.headerIssue = false
        this.fileError = false
        this.totRecs = 0
        this.recsLoaded = []
        this.totValid = 0
        this.totInvalid = 0
        this.totLoaded = 0
        this.totFail = 0

        // read file
        var file = this.$refs.ipFile.files[0]

        var reader = new FileReader()
        reader.onload = (e) => {
          var content = e.target.result

          // validate & show result
          var allLines = content.split(/\r\n|\n/)
          // ignore empty lines if any
          allLines = allLines.filter(rec => !rec.startsWith(',,,,'))
          this.totRecs = allLines.length - 1
          var headers = allLines[0].split(',')
          // 1. header & required columns
          for (var i = 0; i < this.reqHeaders.length; i++) {
            if (headers[i] !== this.reqHeaders[i]) {
              this.validateInProgress = false
              this.validFile = false
              this.headerIssue = true
              return
            }
          }
          // 2. validate each record
          var res = {}
          var curRec = []
          var tmpDt = ''
          for (var j = 1; j < allLines.length; j++) {
            if (allLines[j]) {
              curRec = allLines[j].split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
              res = {'error': ''}
              for (var c = 0; c < this.colNames.length; c++) {
                if (this.colNames[c].is_required && curRec[c] === '') {
                  // special validation
                  res['error'] += this.reqHeaders[c] + ' is empty; '
                } else {
                  res[this.colNames[c].col_name] = curRec[c] && curRec[c].indexOf('"') >= 0 ? curRec[c].split('"').join('') : curRec[c]
                }
              }
              this.recsLoaded.push(res)
              if (res['error']) {
                this.totInvalid++
              } else {
                this.totValid++
              }
              if (res.effective_from) {
                tmpDt = res.effective_from.split('/')
                res.effective_from = handy.formatDBDate(new Date(tmpDt[2], tmpDt[1] - 1, tmpDt[0]))
              } else {
                res.effective_from = null
              }
              if (res.budgeted_salary === '') {
                res.budgeted_salary = 0
              }
              if (res.billing_salary === '') {
                res.billing_salary = 0
              }
              if (res.basic === '') {
                res.basic = 0
              }
              if (res.da === '') {
                res.da = 0
              }
              if (res.hra === '') {
                res.hra = 0
              }
              if (res.conveyance === '') {
                res.conveyance = 0
              }
              if (res.washing_allowance === '') {
                res.washing_allowance = 0
              }
              if (res.other_allowance === '') {
                res.other_allowance = 0
              }
              if (res.leave_wages === '') {
                res.leave_wages = 0
              }
              if (res.medical_reimb === '') {
                res.medical_reimb = 0
              }
              if (res.food_coupon === '') {
                res.food_coupon = 0
              }
              if (res.performance_incentive === '') {
                res.performance_incentive = 0
              }
              if (res.bonus === '') {
                res.bonus = 0
              }
              if (res.child_edu_allowances === '') {
                res.child_edu_allowances = 0
              }
              if (res.other_amt === '') {
                res.other_amt = 0
              }
            }
          }
          if (this.totInvalid) {
            this.validFile = false
          }
          this.validateInProgress = false
        }
        reader.readAsText(file)
      },
      showError (err) {
        this.msg(err, 2)
      },
      async uploadCompensation () {
        // create compensation of employee one by one
        this.readyForLoad = true
        this.loadInProgress = true
        this.beingSaved = true
        var curRec = ''
        for (var i = 0; i < this.recsLoaded.length; i++) {
          curRec = this.recsLoaded[i]
          if (!this.recsLoaded[i].error) { // process only valid records
            // fill-in gaps
            let effectiveTill = new Date(curRec.effective_from)
            curRec.effective_till = handy.formatDBDate(effectiveTill.setDate(effectiveTill.getDate() - 1))
            curRec.gross_salary = Number(curRec.basic) + Number(curRec.da) + Number(curRec.hra) + Number(curRec.washing_allowance) + Number(curRec.other_allowance) + Number(curRec.medical_reimb) + Number(curRec.food_coupon) + Number(curRec.performance_incentive) + Number(curRec.bonus) + Number(curRec.child_edu_allowances) + Number(curRec.other_amt) + Number(curRec.leave_wages) + Number(curRec.conveyance)
            // create record
            await this.axios.post(config.API_URL + '/uploadCompensation/', this.recsLoaded[i])
            .then(response => {
              curRec.load_status = 'Loaded'
              this.totLoaded++
            })
            .catch(err => {
              curRec.error = err.response.data
              curRec.load_status = 'Failed'
              this.totFail++
            })
          }
        } // for every record
        if (!this.totFail) {
          this.msg('Uploaded successfully', 1)
        }
        this.loadInProgress = false
        this.beingSaved = false
      }
    }
  }
  </script>
